"use strict";

exports.__esModule = true;
exports.default = exports.BAR_WIDTH = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _element = require("../utils/dom/element");

var _normalizeWheel = _interopRequireDefault(require("../utils/dom/normalizeWheel"));

var _styles = require("../styles");

var _Bar = _interopRequireDefault(require("./Bar"));

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var BAR_WIDTH = 16;
exports.BAR_WIDTH = BAR_WIDTH;

var Scroll =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Scroll, _PureComponent);

  function Scroll(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.touchStartX = 0;
    _this.touchStartY = 0;
    _this.pixelX = 0;
    _this.pixelY = 0;
    _this.cacheWidth = 0;
    _this.cacheHeight = 0;
    _this.bindInner = _this.bindInner.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindWheel = _this.bindWheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setRect = _this.setRect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScrollX = _this.handleScrollX.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScrollY = _this.handleScrollY.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setStartPoint = _this.setStartPoint.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Scroll.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    setTimeout(this.setRect);
    this.wheelElement.addEventListener('wheel', this.handleWheel, {
      passive: false
    });
    this.wheelElement.addEventListener('touchstart', this.handleTouchStart, {
      passive: true
    });
    this.wheelElement.addEventListener('touchmove', this.handleTouchMove, {
      passive: false
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.scrollWidth !== prevProps.scrollWidth) {
      this.setRect();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.wheelElement.removeEventListener('wheel', this.handleWheel);
    this.wheelElement.removeEventListener('touchstart', this.handleTouchStart);
    this.wheelElement.removeEventListener('touchmove', this.handleTouchMove);
  };

  _proto.getWheelRect = function getWheelRect() {
    if (!this.wheelElement) return {
      width: 0,
      height: 0
    };

    var _this$wheelElement$ge = this.wheelElement.getBoundingClientRect(),
        width = _this$wheelElement$ge.width,
        height = _this$wheelElement$ge.height; // display none


    if (width === 0 && height === 0) {
      width = this.cacheWidth;
      height = this.cacheHeight;
    } else {
      this.cacheWidth = width;
      this.cacheHeight = height;
    }

    var _this$props = this.props,
        scrollX = _this$props.scrollX,
        scrollY = _this$props.scrollY,
        style = _this$props.style;
    width = (style.width || width) - (scrollY ? BAR_WIDTH : 0);
    height = (style.height || height) - (scrollX ? BAR_WIDTH : 0);
    return {
      width: width,
      height: height
    };
  };

  _proto.setRect = function setRect() {
    this.handleScroll(this.props.left, this.props.top);
    this.forceUpdate();
  };

  _proto.setBaseScrollHeightRatio = function setBaseScrollHeightRatio(height) {
    if (this.baseScrollRatio) return;
    this.baseScrollRatio = 1; // windows scroll

    if (Math.abs(height) > 10) {
      this.baseScrollRatio = 60 / Math.abs(height);
    }
  };

  _proto.setStartPoint = function setStartPoint(position) {
    this.touchStartX = position.clientX;
    this.touchStartY = position.clientY;
  };

  _proto.bindInner = function bindInner(el) {
    this.inner = el;
  };

  _proto.bindIframe = function bindIframe(el) {
    if (el && el.contentWindow) {
      el.contentWindow.onresize = this.setRect;
    }
  };

  _proto.bindWheel = function bindWheel(el) {
    this.wheelElement = el;
  };

  _proto.boundleScroll = function boundleScroll() {
    /*
    this.locked = true
    this.scrollTimer = setTimeout(() => {
      this.locked = false
      if (this.pixelX !== 0 || this.pixelY !== 0) {
        this.boundleScroll()
      }
    }, 32)
    */
    // lock direction
    if (Math.abs(this.pixelX) > Math.abs(this.pixelY)) {
      this.pixelY = 0;
    } else {
      this.pixelX = 0;
    }

    var _this$props2 = this.props,
        left = _this$props2.left,
        top = _this$props2.top;
    var _this$props3 = this.props,
        scrollWidth = _this$props3.scrollWidth,
        scrollHeight = _this$props3.scrollHeight;
    var x = left + this.pixelX / scrollWidth;
    if (x < 0) x = 0;
    if (x > 1) x = 1;
    var y = top + this.pixelY / scrollHeight;
    if (y < 0) y = 0;
    if (y > 1) y = 1;

    if (x !== left || y !== top) {
      this.handleScroll(x, y, this.pixelX, this.pixelY);
    }

    this.pixelX = 0;
    this.pixelY = 0;
  };

  _proto.handleWheel = function handleWheel(event) {
    var _this$props4 = this.props,
        scrollX = _this$props4.scrollX,
        scrollY = _this$props4.scrollY;
    if (!scrollX && !scrollY) return;
    var target = (0, _element.getParent)(event.target, "." + (0, _styles.scrollClass)('_'));
    if (target !== this.wheelElement) return;
    var wheel = (0, _normalizeWheel.default)(event);
    this.setBaseScrollHeightRatio(wheel.pixelY);
    if (scrollX) this.pixelX += wheel.pixelX;
    if (scrollY) this.pixelY += wheel.pixelY * this.baseScrollRatio;

    if (Math.abs(wheel.pixelX) > Math.abs(wheel.pixelY)) {
      event.preventDefault();
    } else if (scrollY) event.preventDefault(); // if (!this.locked) {


    this.boundleScroll(); // }
  };

  _proto.handleScroll = function handleScroll(x, y, pixelX, pixelY) {
    var scrollWidth = this.props.scrollWidth;

    var _this$getWheelRect = this.getWheelRect(),
        width = _this$getWheelRect.width,
        height = _this$getWheelRect.height;

    var max = Math.round((1 - width / scrollWidth) * scrollWidth);

    if (this.props.onScroll) {
      this.props.onScroll(x, y, max, this.inner, width, height, pixelX, pixelY);
    }
  };

  _proto.handleScrollX = function handleScrollX(left) {
    this.handleScroll(left, this.props.top, undefined, 0);
  };

  _proto.handleScrollY = function handleScrollY(top) {
    this.handleScroll(this.props.left, top);
  };

  _proto.handleTouchStart = function handleTouchStart(e) {
    this.setStartPoint(e.changedTouches[0]);
  };

  _proto.handleTouchMove = function handleTouchMove(e) {
    var _this$props5 = this.props,
        scrollX = _this$props5.scrollX,
        scrollY = _this$props5.scrollY;
    e.preventDefault();
    var position = e.changedTouches[0];
    var moveX = position.clientX - this.touchStartX;
    var moveY = position.clientY - this.touchStartY;
    if (scrollX) this.pixelX = -moveX;
    if (scrollY) this.pixelY = -moveY; // need reset the start

    this.setStartPoint(position);
    this.boundleScroll();
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        children = _this$props6.children,
        scrollWidth = _this$props6.scrollWidth,
        scrollHeight = _this$props6.scrollHeight,
        left = _this$props6.left,
        top = _this$props6.top,
        scrollX = _this$props6.scrollX,
        scrollY = _this$props6.scrollY,
        style = _this$props6.style;

    var _this$getWheelRect2 = this.getWheelRect(),
        width = _this$getWheelRect2.width,
        height = _this$getWheelRect2.height;

    var className = (0, _classnames.default)((0, _styles.scrollClass)('_', scrollX && 'show-x', scrollY && 'show-y'), this.props.className);
    return _react.default.createElement("div", {
      style: style,
      ref: this.bindWheel,
      className: className
    }, _react.default.createElement("iframe", {
      tabIndex: -1,
      title: "scroll",
      ref: this.bindIframe,
      className: (0, _styles.scrollClass)('iframe')
    }), _react.default.createElement("div", {
      className: (0, _styles.scrollClass)('iframe')
    }), _react.default.createElement("div", {
      ref: this.bindInner,
      className: (0, _styles.scrollClass)('inner')
    }, _react.default.createElement(_context.Provider, {
      value: {
        left: left * width,
        top: top * height,
        element: this.wheelElement
      }
    }, children)), scrollY && _react.default.createElement(_Bar.default, {
      direction: "y",
      length: scrollHeight < height ? scrollHeight : height,
      forceHeight: scrollHeight < height ? scrollHeight : undefined,
      scrollLength: scrollHeight,
      offset: top,
      onScroll: this.handleScrollY
    }), scrollX && _react.default.createElement(_Bar.default, {
      direction: "x",
      length: width,
      scrollLength: scrollWidth,
      offset: left,
      onScroll: this.handleScrollX
    }));
  };

  return Scroll;
}(_component.PureComponent);

Scroll.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  left: _propTypes.default.number.isRequired,
  // overLock: PropTypes.bool,
  top: _propTypes.default.number.isRequired,
  onScroll: _propTypes.default.func.isRequired,
  scrollHeight: _propTypes.default.number,
  scrollWidth: _propTypes.default.number,
  scrollX: _propTypes.default.bool.isRequired,
  scrollY: _propTypes.default.bool.isRequired
});
Scroll.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  // overLock: true,
  scrollHeight: 0,
  scrollWidth: 0
});
var _default = Scroll;
exports.default = _default;